/* eslint-disable no-undef */
import axios from "axios";
import toastr from "toastr";

export default class HttpService {
  static getRequest(url, optionalOptions = {}) {
    const token = localStorage.getItem("accToken") || "";
    const BASEURL = process.env.REACT_APP_API_URL;
    const options = {
      ...optionalOptions,
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
        CacheControl: "no-cache",
        Pragma: "no-cache",
        Expires: "0"
      }
    };
    return axios
      .get(BASEURL + url, options)
      .then(res => {
        return res.data;
      })
      .catch(error => {
        if (error.response.status !== 401) {
          toastr.error(error);
        }
        return { error };
      });
  }

  static getRequestWithHeader(url, optionalOptions = {}) {
    const token = localStorage.getItem("accToken") || "";
    const BASEURL = process.env.REACT_APP_API_URL;
    const options = {
      ...optionalOptions,
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
        CacheControl: "no-cache",
        Pragma: "no-cache",
        Expires: "0"
      }
    };
    return axios.get(BASEURL + url, options).catch(error => {
      toastr.error(error);
      return { error };
    });
  }

  static postRequest(url, body, header = { Accept: "application/json" }) {
    const BASEURL = process.env.REACT_APP_API_URL;
    const token = localStorage.getItem("accToken") || "";
    return axios
      .post(BASEURL + url, body, {
        headers: { ...header, Authorization: `Bearer ${token}` }
      })
      .then(res => {
        return res.data;
      })
      .catch(error => {
        toastr.error(error);
        return { error };
      });
  }

  static putRequest(url, body, optionalOptions = {}) {
    const BASEURL = process.env.REACT_APP_API_URL;
    const token = localStorage.getItem("accToken") || "";
    const options = {
      ...optionalOptions,
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
        "Content-Type": "application/json"
      }
    };
    return axios
      .put(BASEURL + url, body, options)
      .then(res => {
        return res.data;
      })
      .catch(error => {
        toastr.error(error);
        return { error };
      });
  }

  static deleteRequest(url, data = {}) {
    const BASEURL = process.env.REACT_APP_API_URL;
    const token = localStorage.getItem("accToken") || "";
    return axios
      .delete(BASEURL + url, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json"
        },
        data
      })
      .then(res => {
        return res.data;
      })
      .catch(error => {
        toastr.error(error);
        return { error };
      });
  }
}
